import { Pipe, PipeTransform } from '@angular/core';
import { SyncedStorage } from './synced-storage';

@Pipe({
  name: 'toUntypedId'
})
export class ToUntypedIdPipe implements PipeTransform {

  transform(_id: string): string {
    return SyncedStorage.toUntypedDocId(_id);
  }
}
